import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { appName } from '../../../utils/Variables';
import * as Reqst from '../../../utils/Reqst';
import Sanitize from '../../../utils/Sanitize';
import { notify } from 'react-notify-toast';
import { Helmet } from "react-helmet";
import $ from 'jquery';
import { Row, Col, Table, Modal, Card } from 'react-bootstrap';
import "react-bootstrap-toggle/dist/bootstrap2-toggle.css";
import Roles from '../../../utils/Roles';
import swal from 'sweetalert';
import Pagination from "react-js-pagination";
import Select from 'react-select';
import PageTitle from '../../../containers/PageTitle';

const styles = {
	cardTitle: {
		paddingBottom: '5px',
		backgroundColor: '#ffd3e7',
		padding: '5px',
		fontSize: '15px',
		fontWeight: '700',
		border: '1px solid grey',
		cursor: 'pointer',
	},
	profileImg: {
		width: '100px',
		border: '1px solid grey',
	},
	expiryStyle: {
		backgroundColor: '#efb6b6',
		padding: '4px'
	}
}

class AppointmentOrder extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loginId: Sanitize.getData('labUser_id'),
			companyId: Sanitize.getData('labUser_clientid'),
			masterId: Sanitize.getData('labUser_masterid'),
			loginText: 'LOGIN',
			saveText: 'SAVE',
			isRedirect: false,
			showAddModal: false,
			showEditModal: false,
			currentPage: 1,
			todosPerPage: 10,
			activePage: 1,
			dataSelect: [],
			renewData: [],
			dataList: [],
			editData: [],
			showModal: false,
			rData: [],
		}

		this.onhandleCandidate = this.onhandleCandidate.bind(this);
		this.handleFormSubmit = this.handleFormSubmit.bind(this);
	}

	onRenew(index, e) {
		this.setState({ showModal: !this.state.showModal, rData: this.state.dataView[index] });
	}

	componentDidMount() {
		this.loadSelectedEmp();		
	}

	loadSelectedEmp() {
		this.setState({ showLoader: true });
		var token = Reqst.TimeStamp();
		Reqst.axGet('interview/getSelectionList/' + this.state.masterId + '/' + this.state.companyId + '/' + token).then(res => {
			if (res['data'].status == '1') {
				this.setState({ dataSelect: res['data'].data, showLoader: false });
			}
			else {
				notify.show(res['data'].msg, 'error');
				this.setState({ showLoader: false });
			}
		});
	}

	loadEmployees() {
		this.setState({ showLoader: true });
		var token = Reqst.TimeStamp();
		Reqst.axGet('interview/getEmployeeDataById/'+ this.state.candidate + '/' + this.state.masterId + '/' + this.state.companyId  + '/' + token).then(res => {
			if (res['data'].status == '1') {
				this.setState({ dataList: res['data'].data, showLoader: false });
			}
			else {
				notify.show(res['data'].msg, 'error');
				this.setState({ showLoader: false });
			}
		});
	}
	

	onhandleCandidate(e) {
		this.state.candidate = e.target.value;
		this.loadEmployees();
	}


	handleFormSubmit(e) {
		e.preventDefault();
		swal({
			title: 'Confirm',
			text: 'Do you want to Renewal?',
			buttons: ['No', 'Yes']
		}).then((willYes) => {
			if (willYes) {
				this.setState({ showLoader: true, saveText: 'Processing..' });
				var formData = Sanitize.objectifyForm($("#frmEmp").serializeArray());
				Reqst.axPost('employee/renewdd', { token: Reqst.Token(formData) }).then(res => {
					if (res['data'].status == '1') {
						notify.show(res['data'].msg, 'success');
						this.setState({ showLoader: false, saveText: 'SAVE' });
						//this.props.afterFinish();
					}
					else {
						notify.show(res['data'].msg, 'error');
						this.setState({ showLoader: false, saveText: 'SAVE' });
					}
				});
			}
		});
	}

	render() {

		this.coursetype = [
			{ value: 'UG', name: 'UG' },
			{ value: 'PG', name: 'PG' }
		];

		let d = this.state.dataList;
		var today = new Date();
		var preyear = today.getFullYear() - 2;
		var curyear = today.getFullYear();

		let YearList = [];
		YearList.push(<option value="">Year</option>);
		for (var i = ((new Date()).getFullYear()); i >= ((new Date()).getFullYear()); i--) {
			YearList.push(<option value={i}> {i} </option>);
		}

		return (
			<div>
				<Helmet>
					<title>{appName} | Admission Process</title>
				</Helmet>

				<PageTitle title="Certificate Verification" loading={this.state.showLoader} >
					{/*<div className="text-right">
						{Roles.Can('employee','registration','canadd') ?
							<Link to="/employee/registration" className="btn btn-info btn-sm" >
							<i className="fa fa-plus"></i>  Add Employee
						</Link> : null }
						&nbsp;
						<button className="btn btn-info btn-sm" onClick={this.loadTestMasters} >
							<i className="fa fa-refresh"></i> 
						</button>
					</div>*/}
				</PageTitle>

				<Row style={{ marginBottom: 5 }} >
					<Col md={2} >
						<label>Select Candidate : </label>
					</Col>
					<Col md={3} >
						<select name="dept" id="dept" className="form-control input-sm" onChange={this.onhandleCandidate.bind(this)}>
							<option value="">--Select--</option>
							{this.state.dataSelect.map((item, i) =>
								<option value={item.empid} >{item.name}</option>
							)}
						</select>
					</Col>
				</Row><br />
				<Row>
					{this.state.dataList.length > 0 ?
						<form action="" id="frmEmp" style={{ width: "100%" }} method="post" encType="multipart/form-data" onSubmit={this.handleFormSubmit}>
							<input type="hidden" name="i__lid" value={this.state.loginId} />
							<input type="hidden" name="i__company" value={this.state.companyId} />
							<input type="hidden" name="i__master" value={this.state.masterId} />
							<input type="hidden" name="i__seniority" value={d[0].seniority} />
							<input type="hidden" name="i__eid" value={d[0].id} />
							<Col md={12} >
								<Card>
									<Card.Body>
										<Row>
											<Col md={12} style={{ paddingLeft: '20px' }}>
												<table width="100%" style={{ fontSize: "15px" }}>
													<tbody>
														<tr>
															<td style={{ width: "10%", padding: "10px" }}>Name</td>
															<td style={{ width: "5%", padding: "10px" }}> : </td>
															<td style={{ width: "35%", padding: "10px" }}><b>{d[0].name}</b></td>
															<td style={{ width: "10%", padding: "10px" }}>  </td>
															<td style={{ width: "10%", padding: "10px" }}>Dob</td>
															<td style={{ width: "5%", padding: "10px" }}> : </td>
															<td style={{ width: "35%", padding: "10px" }} align="left">{Sanitize.dmyDash(d[0].dob)}</td>
														</tr>
														<tr>
															<td style={{ width: "10%", padding: "10px", verticalAlign: "top" }}>Address</td>
															<td style={{ width: "5%", padding: "10px", verticalAlign: "top" }}> : </td>
															<td style={{ width: "35%", verticalAlign: "top", padding: "10px" }}>{d[0].address} - {d[0].pincode}</td>
															<td style={{ width: "10%", padding: "10px" }}>  </td>
															<td style={{ width: "10%", padding: "10px" }}>Mobile</td>
															<td style={{ width: "5%", padding: "10px" }}> : </td>
															<td style={{ width: "35%", padding: "10px" }} align="left">{d[0].mobile}</td>
														</tr>
														<tr>
															<td style={{ width: "10%", padding: "10px" }}>Category</td>
															<td style={{ width: "5%", padding: "10px" }}> : </td>
															<td style={{ width: "35%", padding: "10px" }}>{d[0].categoryname}</td>
															<td style={{ width: "10%", padding: "10px" }}>  </td>
															<td style={{ width: "10%", padding: "10px" }}>Qualification</td>
															<td style={{ width: "5%", padding: "10px" }}> : </td>
															<td style={{ width: "35%", padding: "10px" }} align="left">{d[0].qualification}</td>
														</tr>
														<tr>
															<td style={{ width: "15%", padding: "10px" }}>Registration On</td>
															<td style={{ width: "5%", padding: "10px" }}> : </td>
															<td style={{ width: "35%", padding: "10px" }}>{d[0].for_year}</td>
															<td style={{ width: "5%", padding: "10px" }}>  </td>
															<td style={{ width: "10%", padding: "10px" }}>Last Renew</td>
															<td style={{ width: "5%", padding: "10px" }}> : </td>
															<td style={{ width: "35%", padding: "10px" }} align="left">{d[0].renew_year == null ? d[0].lastrenew_year : d[0].renew_year}</td>
														</tr>
														<tr>
															<td colSpan={3}></td>
														</tr>
														{/*<tr style={(d[0].renew_year == null ? d[0].lastrenew_year : d[0].renew_year) < preyear ? styles.expiryStyle : { backgroundColor: '' }}>
															<td style={(d[0].renew_year == null ? d[0].lastrenew_year : d[0].renew_year) < preyear ? styles.expiryStyle : { backgroundColor: '' }}>Last Renew</td>
															<td> : </td>
															<td>{d[0].renew_year == null ? d[0].lastrenew_year : d[0].renew_year}</td>
														</tr>*/}
													</tbody>
												</table>
											</Col>
										</Row>
									</Card.Body>
								</Card>
							</Col><br />
							<Row style={{ marginTop: '10px', marginLeft: "5px" }}>
								<Col md={3}>
									<label>Select School<span className="text-danger">*</span></label>
									<input type="text" name="a__school" className="form-control input-sm" required />
								</Col>
								<Col md={3}>
									<label>Select Date <span className="text-danger">*</span></label>
									<input type="date" name="r_date" className="form-control input-sm" required />
								</Col>
								<Col md={3}>
									<label>Appoint By Whom<span className="text-danger">*</span></label>
									<input type="text" name="date" className="form-control input-sm" required />
								</Col>
								<Col md={2}>
									<div className="text-right">
										<button style={{ marginTop: '20px' }} type="submit" className="btn btn-success btn-sm" disabled={this.state.saveText != 'SAVE'} >
											<i className="fa fa-check"></i> {this.state.saveText}
										</button>
									</div>
								</Col>
							</Row>
						</form> : ''}
				</Row>
			</div>
		);
	}

}
export default AppointmentOrder;